import { KeyValue, KeyValueDefault } from "@/main/models/common";
import { InsurerFilterRequest, UsersByInsurerFilterRequest } from "@/main/models/request/insurerRequest";

export enum InsurerTypes {
	GET_INSURERS = "@insurer/GET_INSURERS",
	SAVE_INSURERS = "@insurer/SAVE_INSURERS",
	GET_INSURERS_PUBLIC = "@insurer/GET_INSURERS_PUBLIC",
	SAVE_INSURERS_PUBLIC = "@insurer/SAVE_INSURERS_PUBLIC",
	RESET_REDUCER_INSURERS = "@insurer/RESET_REDUCER_INSURERS",
	GET_INSURERS_FULL = "@insurer/GET_INSURERS_FULL",
	SAVE_INSURERS_FULL = "@insurer/SAVE_INSURERS_FULL",
	GET_INSURERS_USERS_BY_INSURER = "@insurer/GET_INSURERS_USERS_BY_INSURER",
	SAVE_INSURERS_USERS_BY_INSURER = "@insurer/SAVE_INSURERS_USERS_BY_INSURER",
	RESET_REDUCER_INSURERS_FULL = "@insurer/RESET_REDUCER_INSURERS_FULL",
}

export interface InsurerState {
	readonly insurers: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
	readonly insurersPublic: {
		data: KeyValueDefault[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
	readonly insurersFull: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
	readonly usersByInsurerFull: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
	readonly isolated: {
		[key: string]: {
			data: KeyValue[] | null;
			errorMessages: string[] | null;
			isError: boolean;
			isLoading: boolean;
		};
	};
}

export interface GetInsurers {
	type: typeof InsurerTypes.GET_INSURERS;
	payload: {
		request: InsurerFilterRequest;
		keyReducer: string;
	};
}

export interface SaveInsurers {
	type: typeof InsurerTypes.SAVE_INSURERS;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
		keyReducer: string;
	};
}
export interface GetInsurersPublic {
	type: typeof InsurerTypes.GET_INSURERS_PUBLIC;
	payload: {
		guidCountry: string;
		keyReducer: string;
	};
}

export interface SaveInsurersPublic {
	type: typeof InsurerTypes.SAVE_INSURERS_PUBLIC;
	payload: {
		data: KeyValueDefault[] | null;
		isError: boolean;
		errorMessages: string[] | null;
		keyReducer: string;
	};
}

export interface ResetReducerInsurers {
	type: typeof InsurerTypes.RESET_REDUCER_INSURERS;
}

export interface GetInsurersFull {
	type: typeof InsurerTypes.GET_INSURERS_FULL;
	payload: {
		request: InsurerFilterRequest;
	};
}

export interface SaveInsurersFull {
	type: typeof InsurerTypes.SAVE_INSURERS_FULL;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface GetUsersByInsurer {
	type: typeof InsurerTypes.GET_INSURERS_USERS_BY_INSURER;
	payload: {
		request: UsersByInsurerFilterRequest;
	};
}

export interface SaveUsersByInsurer {
	type: typeof InsurerTypes.SAVE_INSURERS_USERS_BY_INSURER;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerInsurersFull {
	type: typeof InsurerTypes.RESET_REDUCER_INSURERS_FULL;
}

export type InsurerActionTypes =
	| GetInsurers
	| SaveInsurers
	| GetInsurersPublic
	| SaveInsurersPublic
	| ResetReducerInsurers
	| GetInsurersFull
	| GetUsersByInsurer
	| SaveUsersByInsurer
	| SaveInsurersFull
	| ResetReducerInsurersFull;
